import { Component,OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { filter, map, takeUntil, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <!-- <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar> -->

      <nb-layout-column class={{scssclass}}>
        <ng-content  select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit {
  private destroy$: Subject<void> = new Subject<void>();
  clientusername: any;
  appname: any;
  clientname: any;
  scssclass: string;
  constructor(public _AuthenticationService: AuthenticationService,){}

  ngOnInit(): void {
    this._AuthenticationService.getUserData()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => {
        this.clientusername = users.data.username;
        this.appname = users.data.application;
        this.getclient()
      });
  }

  getclient(){
  //  this._AuthenticationService.getusercontroldata(this.clientusername, this.appname)
 //   .subscribe(res => {
  //    console.log(res.data[0][0],'client data');
  //    this.clientname = res.data[0][0].clientName;
  this.clientname = localStorage.getItem('clientIDE');
  console.log(this.clientname,'client name in one-column layout');
      if(this.clientname=="Royal Enfield RSA"){
        this.scssclass="RE";
      }else if(this.clientname=="Vodafone RSA"){
        this.scssclass="vodafone";
      }
 //   });
  }
}
